import {ErrorResponse} from "../../../swagger";
import {action, observable} from "mobx";

export type ErrorMap = Map<string, ErrorResponse[]>

export class ErrorsStore {
  @observable
  public errorMap: ErrorMap = new Map([["default", []]]);

  @action
  clearErrors(key: string) {
    this.errorMap.set(key, []);
  }

  @action
  addError(key: string, error: ErrorResponse) {
    const errors = this.errorMap.get(key) || [];
    errors.push(error);
    this.errorMap.set(key, errors);
  }

  @action
  addErrors(key: string, errors: ErrorResponse[]) {
    const existingErrors = this.errorMap.get(key) || [];
    this.errorMap.set(key, [...existingErrors, ...errors]);
  }
}

export const errorsStore = new ErrorsStore();

